import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const journalEntriesStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageTitle: {
      fontSize: 32,
      marginBottom: 8,
      color: "rgb(55,55,90)",
    },
    pageTitleAlt: {
      marginTop: 48,
    },
    backBtnContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      fontSize: 16,
      cursor: "pointer",
      maxWidth: 100,
      marginBottom: 24,
    },
    rootGrid: {
      "@media (max-width: 960px)": {
        flexDirection: "column-reverse",
      },
    },
    page: {},
    questionParagraph: {
      marginBottom: 12,
    },
    stageOfChangeGrid: {
      marginBottom: 24,
    },
    questionGrid: {
      marginBottom: 48,
    },
    sectionGrid: {
      backgroundColor: "#f8f8ff",
      borderRadius: 24,
      border: "5px solid #CCD9DD",
      padding: 24,
    },
    sectionGridLastItem: {
      marginBottom: 0,
    },
    stageOfChangeTitle: {
      fontSize: 26,
      marginTop: 16,
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: "bold",
    },
    question: {
      fontWeight: "bold",
    },
    tocTitle: {
      fontSize: 20,
      marginBottom: 24,
    },
    tocList: {
      listStyle: "none",
      paddingLeft: 0,
    },
    tocListItem: {
      fontSize: 16,
      marginBottom: 16,
      textDecoration: "underline",
      color: "#002655",
      cursor: "pointer",
    },
    journalEntriesList: {
      listStyle: "none",
      paddingLeft: 0,
    },
    journalEntriesListPrompt: {
      fontSize: 16,
      marginBottom: 24,
      color: "rgb(55,55,90)",
    },
    notApplicableList: {
      listStyle: "none",
      paddingLeft: 0,
    },
    headerGrid: {
      padding: "12px 8px",
      borderBottom: "1px solid #CCD9DD",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      width: "100%",
    },
    tocSubTitle: {
      fontSize: 20,
      textTransform: "uppercase",
      color: "rgb(26, 34, 73)",
      fontWeight: "bold",
      "@media (max-width: 600px)": {
        fontSize: 18,
      },
    },
    journalEntriesListTitle: {
      fontSize: 20,
      textTransform: "uppercase",
      color: "rgb(26, 34, 73)",
      fontWeight: "bold",
      margin: "24px 12px 36px 0px",
    },
    journalEntriesListItem: {
      fontSize: 18,
      marginBottom: 16,
      textDecoration: "none",
      color: "rgb(26, 34, 73) !important",
      cursor: "pointer",
      fontWeight: "bold",
      "@media (max-width: 600px)": {
        marginBottom: 24,
      },
    },
    journalEntriesListItemInner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      width: "100%",
      position: "relative",
      "&:after": {
        content: '""',
        position: "absolute",
        height: 0,
        width: 0,
        bottom: -2,
        borderBottom: "2px solid #002655",
        transition: "0.25s ease-in-out",
      },
      "&:hover": {
        "&:after": {
          width: "100%",
        },
      },
    },
    journalEntriesListItemDate: {
      fontWeight: "normal",
    },
    journalEntriesListItemGridItem: {
      maxWidth: "50%",
    },
    borderedCardAlt: {
      padding: "64px 48px 48px",
      "@media (max-width: 600px)": {
        padding: "64px 12px 48px",
      },
    },
    titleContainer: {
      padding: "48px 12px 12px 12px",
    },
  })
);
